































































































import Vue from "vue";
import qs from "qs";
import SiteHeader from "@/components/Header.vue";
import FeedFileItem from "@/components/detail/FeedFileItem.vue";
import Avatar from "@/components/Avatar.vue";
import feedMixin from "@/mixins/feed";
import ssoMixin from "@/mixins/sso";
import { formatSize, joinUrlQueryString, getCookie } from "@/utils/util";
import { formatPublishTime } from "@/utils/filters";
import staticIcons from "@/utils/static-icons";
import eventEmitter from "@/utils/eventEmitter";
import { IFeedItem } from "@/types/post";
import ContentEmpty from "@/components/Empty.vue";
import DownloadDialog from "@/components/DownloadDialog.vue";
import SiteShare from "@/components/Share.vue";
import DownloadTipDialog from "@/components/DownloadTipDialog.vue";
import Comment from "@/components/detail/Comment.vue";
import FeedInfo from "@/components/detail/FeedInfo.vue";
import eventMap from "@/utils/event-name";

export default Vue.extend({
  components: {
    SiteHeader,
    FeedFileItem,
    ContentEmpty,
    DownloadDialog,
    SiteShare,
    DownloadTipDialog,
    Comment,
    Avatar,
    FeedInfo,
  },
  filters: {
    formatPublishTime,
    displayFileIcon(item: any) {
      return item.icon_link || staticIcons.other;
    },
  },
  mixins: [feedMixin, ssoMixin],
  async asyncData({ store, params, req }) {
    let useridStr = "";
    if (req && req.headers) {
      const cookieStr = req.headers.cookie || "";
      useridStr = getCookie("cur_userid_xz", cookieStr);
    }

    try {
      if (!useridStr && req && req.headers) {
        const feedId = params.feed;
        const [details] = await Promise.all([
          store.dispatch("post/fetchFeedInfo", { id: feedId }),
        ]);
        console.log("asyncData details >>>", details);

        return {
          details,
          error: "ssr",
        };
      } else {
        console.log("asyncData detail error >>>", useridStr);
        return {
          error: "none",
        };
      }
    } catch (e) {
      console.log("asyncData detail error >>>", e);
      return {
        error: "none",
      };
    }
  },
  data() {
    return {
      error: "csr",
      withCaptcha: false,
      feedId: this.$route.params.feed,
      showMore: false,
      folderId: "0",
      fileSelected: [],
      checkAll: false,
      from: this.$route.query.d_from,
      needExpand: false,
      downloadVisible: false,
      feedToDownload: {},
      selectedFiles: [],
      downloadTipVisible: false,
      downloadClicked: false,
      uploadListVisible: false,
      zoneInfo: {},
      fixedInfo: false,
      cardZoneName: "",
    };
  },
  head() {
    return {
      title: this.info.title
        ? `${this.info.title} - 迅雷小站 - 精品资源下载站`
        : "迅雷小站 - 精品资源下载站",
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.keywords,
        },
      ],
    };
  },
  computed: {
    curUser() {
      return this.$store.state.user.curUser;
    },
    hasLogin() {
      return this.curUser.userId !== "0";
    },
    isVip() {
      return this.curUser.vipData && this.curUser.vipData.isVip;
    },
    zhanInfo() {
      return this.$store.state.post.zhanInfo;
    },
    info() {
      return this.$store.state.post.feedInfo;
    },
    folders() {
      return this.$store.state.share.folders;
    },
    shareStore() {
      return this.$store.state.share;
    },
    pageToken() {
      return this.shareStore.pageToken;
    },
    fileIds() {
      return this.shareStore.list;
    },
    allShareFiles() {
      return this.shareStore.files;
    },
    files() {
      if (this.folderId === "0") {
        return this.info.files;
      } else {
        const fileList = this.fileIds.map((id: string) => {
          return this.allShareFiles[id];
        });
        return fileList;
      }
    },
    description() {
      const regx = /<[^<>]+>/g;
      if (this.info.describe) {
        const newDesc = this.info.describe.replace(regx, "");
        if (newDesc.trim()) {
          return newDesc.slice(0, 150);
        }
      }
      return this.info.title;
    },
    keywords() {
      const words: string[] = [];
      if (this.info.labels && this.info.labels.length) {
        this.info.labels.map((label: string) => {
          words.push(label);
        });
      }

      for (let file of this.info.files.slice(0, 5)) {
        words.push(file.name);
      }

      if (words.length === 0) {
        words.push(this.info.title);
      }

      return words.join(",");
    },
    queryStr() {
      const queryObj = this.$route.query;
      const routeName = this.$route.name;
      const queryStr = joinUrlQueryString(queryObj, routeName);
      return queryStr;
    },
    isPcClient() {
      if (process.client) {
        return !!window.native;
      }
      return this.$store.state.isPCNative;
    },
    feedComment() {
      return this.$store.state.post.feedComment;
    },
    total() {
      return this.feedComment.total;
    },
    payParams() {
      return this.$store.state.vip.payParams;
    },
    detailUrl() {
      if (this.info.partner) {
        const infoStr = qs.stringify({
          partner: this.info.partner,
          tid: this.info.tid,
          rid: this.info.id,
        });
        return `/blank/third/?${infoStr}&${this.queryStr}`;
      }
      return "/";
    },
  },
  async mounted() {
    window.addEventListener("scroll", this.handleScroll);
    document.documentElement.style.scrollBehavior = "smooth";
    const from = this.$route.query.d_from;
    const zoneName = this.$route.query.zone;

    if (zoneName) {
      this.cardZoneName = encodeURIComponent(this.$xss(zoneName));
    }

    eventEmitter.on("save-success-detail", (type: string) => {
      this.$refs.message.show();
    });

    eventEmitter.on("feed-download-fail", (item: IFeedItem) => {
      this.feedToDownload = item;
      this.downloadVisible = true;
    });

    eventEmitter.on("open-mac-download", ({ files, links }: any) => {
      this.feedToDownload = { files, directLinks: links };
      this.downloadVisible = true;
    });

    if (this.$refs.detailRef) {
      // csr in case of ssr error
      const ssrStatus = this.$refs.detailRef.getAttribute("data-ssr");
      if (ssrStatus === "none" || (this.hasLogin && ssrStatus === "ssr")) {
        const feedId = this.$route.params.feed;
        const result = await this.$store.dispatch("post/fetchFeedInfo", {
          id: feedId,
        });

        if (result && result.second_zone_id) {
          const zoneId = result.second_zone_id;
          const zoneInfo = await this.$store.dispatch("post/fetchZoneInfo", {
            zone_id: zoneId,
            from: "detail",
          });
          this.zoneInfo = zoneInfo;
        }
      }
    }

    this.stat("xiaozhan_card_detail_page_show", {
      from,
      cardID: this.feedId,
      need_vip: this.info.payment === 2 ? 1 : 0,
      zone_name: this.cardZoneName,
      resource_type: this.info.partner || "normal",
    });

    setTimeout(() => {
      this.stat("xiaozhan_vip_detailwzl_pay_show", {
        cardID: this.info.id,
        referfrom: "v_wap_xiaozhan_ggong_detail_wzl",
        aidfrom: this.payParams.aidfrom,
        zone_name: this.cardZoneName,
      });

      if (this.info.payment == 2) {
        this.stat("xiaozan_vip_detail_pay_show", {
          cardID: this.info.id,
          referfrom: "v_wap_xiaozhan_ggong_detail_but",
          aidfrom: this.payParams.aidfrom,
          zone_name: this.cardZoneName,
        });
      }
    }, 800);
  },
  beforeDestroy() {
    eventEmitter.off("feed-download-fail", 0);
    window.removeEventListener("scroll", this.handleScroll);
    document.documentElement.style.scrollBehavior = "";
  },
  methods: {
    formatSize,
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    describeXss(describe: string) {
      return this.$xss(describe.trim(), {
        onTagAttr: function (
          tag: string,
          name: string,
          value: string,
          isWhiteAttr: boolean
        ) {
          if (name.substring(0, 4) === "href") {
            return "";
          }
        },
      });
    },
    handleCheckUser() {
      this.stat("xiaozhan_card_detail_page_click", {
        from: this.from,
        clickid: "entry_station",
        cardID: this.info.id,
        need_vip: this.info.payment === 2 ? 1 : 0,
        resource_type: this.info.partner || "normal",
      });
    },
    async handleSaveClick(info: IFeedItem) {
      if (info.favor && info.favor.is_favor) {
        try {
          await this.$store.dispatch("post/cancelFavoriteFeed", {
            rid: info.id,
          });
          this.$message({
            type: "success",
            message: "取消收藏成功",
          });
        } catch (e) {
          this.$message({
            type: "warning",
            message: "取消收藏失败",
          });
        }

        this.stat("xiaozhan_cancel_collect_btn_click", {
          from: this.from,
          position: "detail_page",
          upUid: info.user_info ? info.user_info.user_id : "",
          cardID: info.id,
          need_vip: info.payment === 2 ? 1 : 0,
          zone_name: this.cardZoneName,
        });
        return;
      }

      this.stat("xiaozhan_card_detail_page_click", {
        from: this.from,
        clickid: "collect",
        cardID: this.info.id,
        need_vip: this.info.payment === 2 ? 1 : 0,
        zone_name: this.cardZoneName,
        resource_type: this.info.partner || "normal",
      });

      this.stat("xiaozhan_collect_btn_click", {
        from: this.from,
        position: "detail_page",
        is_collect_all_file: 1,
        is_login: this.hasLogin ? 1 : 0,
        upUid: this.info.user_info ? this.info.user_info.user_id : "",
        cardID: this.info.id,
        need_vip: this.info.payment === 2 ? 1 : 0,
        zone_name: this.cardZoneName,
      });

      this.handleSave(info, null, [], "detail", true, this.from, {
        zone_name: this.cardZoneName,
      });
    },
    getShare(more = false, config = {}) {
      let shareId = this.info.source_id || this.info.share_id;

      if (shareId) {
        shareId = shareId.split("").reverse().join("");
      }

      const params = {
        share_id: shareId,
        pass_code: "",
        limit: 100,
        pass_code_token: "",
        page_token: more ? this.pageToken : "",
      };
      this.isFetching = true;
      this.isLoading = more ? false : true;

      return this.$store
        .dispatch("share/getShare", {
          params,
          withCaptcha: true,
          withCredentials: this.hasLogin,
        })
        .then(async (res: any) => {
          this.internalError = false;
          this.isLoading = false;
          this.withCaptcha = true;
          this.backFetch();

          if (res.share_status === "PASS_CODE_ERROR") {
            this.checkCodeMessage = "提取码错误，请重新输入";
          } else {
            if (res.share_status === "OK") {
            }
          }
        })
        .catch((err: any) => {
          this.internalError = true;
          this.isLoading = false;
          this.backFetch();
          this.$message({
            message: err.error_description,
            type: "error",
          });
        });
    },
    getDetail(more = false, pathName = null) {
      this.isFetching = true;
      this.isLoading = more ? false : true;
      pathName &&
        this.$store.commit("share/setFolder", {
          id: this.folderId,
          title: pathName,
        });

      let shareId = this.info.source_id || this.info.share_id;

      if (shareId) {
        shareId = shareId.split("").reverse().join("");
      }

      const params = {
        share_id: shareId,
        parent_id: this.folderId,
        pass_code_token: "",
        limit: 100,
        page_token: more ? this.pageToken : "",
      };
      this.$store
        .dispatch("share/getDetail", {
          params,
          withCredentials: this.hasLogin,
        })
        .then(() => {
          this.isLoading = false;
          this.backFetch();
        })
        .catch((err: any) => {
          this.isLoading = false;
          this.backFetch();
          this.$message({
            message: err.error_description,
            type: "error",
          });
        });
    },
    backFetch() {
      this.isFetching = false;
    },
    reportActionStat() {
      if (this.info.payment == 2) {
        this.stat("xiaozan_vip_detail_pay_click", {
          cardID: this.info.id,
          referfrom: "v_wap_xiaozhan_ggong_detail_but",
          aidfrom: this.payParams.aidfrom,
          need_vip: this.info.payment === 2 ? 1 : 0,
          zone_name: this.cardZoneName,
        });

        this.$store.commit("vip/SET_PAY_PARAMS", {
          referfrom: "v_wap_xiaozhan_ggong_detail_but",
          cardID: this.info.id,
          zone_name: this.cardZoneName,
          need_vip: this.info.payment === 2 ? 1 : 0,
        });
      }

      this.stat("xiaozhan_card_detail_page_click", {
        from: this.from,
        clickid: "download",
        cardID: this.info.id,
        need_vip: this.info.payment === 2 ? 1 : 0,
        zone_name: this.cardZoneName,
        resource_type: this.info.partner || "normal",
      });

      this.stat("xiaozhan_download_btn_click", {
        from: this.from,
        position: "detail_page",
        is_collect_all_file: 1,
        is_login: this.hasLogin,
        upUid: this.info.user_info ? this.info.user_info.user_id : "",
        cardID: this.info.id,
        need_vip: this.info.payment === 2 ? 1 : 0,
        zone_name: this.cardZoneName,
      });
    },
    jumping(e: Event) {
      this.reportActionStat();
    },
    handleDownloadClick() {
      this.reportActionStat();
      // 暂时不删除，留以后用
      // const downloadTipDialogVisible = store.get("download_tip_dialog_visible");
      // if (window.native && !downloadTipDialogVisible) {
      //   this.downloadTipVisible = true;
      //   return;
      // }

      this.handleDownload(this.info, this.from, "detail_page", [], {
        zone_name: this.cardZoneName,
      });
    },
    handleDownloadConfirm() {
      this.handleDownload(this.info, this.from, "detail_page", [], {
        zone_name: this.cardZoneName,
      });
    },
    handleDownloadDialogClose() {
      this.downloadVisible = false;
      this.selectedFiles = [];
    },
    onVipPay() {
      this.stat("xiaozhan_vip_detailwzl_pay_click", {
        cardID: this.info.id,
        referfrom: "v_wap_xiaozhan_ggong_detail_wzl",
        aidfrom: this.payParams.aidfrom,
        need_vip: this.info.payment === 2 ? 1 : 0,
        zone_name: this.cardZoneName,
      });

      if (!this.hasLogin) {
        this.popLogin("vip");
        return;
      }

      this.$store.commit("vip/SET_PAY_PARAMS", {
        referfrom: "v_wap_xiaozhan_ggong_detail_wzl",
        cardID: this.info.id,
        zone_name: this.cardZoneName,
        need_vip: this.info.payment === 2 ? 1 : 0,
      });

      eventEmitter.emit(eventMap.SHOW_PAY_DIALOG, 0, {});
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 50) {
        this.fixedInfo = true;
      } else {
        this.fixedInfo = false;
      }
    },
  },
});
